function hexToRgba(color: string) {
  // Remover o símbolo # se estiver presente
  const hex = color.replace('#', '')
  const hasAlpha = hex.length > 6

  // Converter hexadecimal para decimal (cada par de caracteres representa um valor decimal)
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const a = hasAlpha ? parseInt(hex.substring(6, 8), 16) / 255 : 1

  return [r, g, b, a]
}

function rgbaToHex(...rgba: [number, number, number, number]) {
  const [r, g, b, a] = rgba
  // Converter cada componente para hexadecimal
  const hexR = (`00${r.toString(16)}`).slice(-2)
  const hexG = (`00${g.toString(16)}`).slice(-2)
  const hexB = (`00${b.toString(16)}`).slice(-2)
  const hexA = (`00${Math.round(a * 255).toString(16)}`).slice(-2)

  // Combinar os valores hexadecimais
  return `#${hexR}${hexG}${hexB}${hexA}`
}

export function addTransparencyToHex(hexColor: `#${string}`, transparency = 0.5) {
  // Converter hexadecimal para RGBA
  const rgbaColor = hexToRgba(hexColor)
  // Extrair os componentes RGBA
  const [r, g, b, a] = rgbaColor
  // Calcular o novo valor de alpha
  const newA = a * transparency
  // Converter de volta para hexadecimal com o novo alpha
  return rgbaToHex(r, g, b, newA)
}
export const tagColors = {
  orange: '#EF7272',
  darkPurple: '#9747FF',
  purple: '#A993FF',
  green2: '#51EB85',
  primary: '#FF88EC',
  chatGPT: '#29C27F',
  admin: '#FBBF24',
  purple1: '#5824FB',
  tagPink: '#FA5892',
  tagBlue: '#4399FF',
  tagGreen: '#70C548',
  tagOrange: '#FFBF43',

}
export function getRandomColors(): [string, string] {
  // const randomColor = () => {
  //   const keys = Object.keys(tagColors)
  //   const index = Math.floor(Math.random() * keys.length)
  //   return tagColors[keys[index] as keyof typeof tagColors]
  // }
  const randomColor = () => Math.floor(Math.random() * 16777215).toString(16)
  const color2 = addTransparencyToHex(randomColor() as `#${string}`, 0.3)
  return ['#21242C', color2]
}
// export function getRandomColors(): [string, string] {
//   const randomColor = () => Math.floor(Math.random() * 16777215).toString(16)
//   const color1 = `#${randomColor()}` as `#${string}`
//   const color2 = addTransparencyToHex(color1, 0.3)
//   return [color1, color2]
// }
